var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import VideoPlayer from './VideoPlayer';
import { VideoContainer } from './VideoViewer.style';
/**
 * This component plays videos from the content-api.
 *
 * WARNING: If you have odd looking words where the icons should be (in the video bar), it is because you must install the Material Icons font (in the <head>):
 * <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
 * @param componentValues @see VideoComponentValues
 * @param muxDataKey This should come from environment variables. A sample of a possible name would be REACT_APP_MUX_DATA_ENV_KEY.
 */
const VideoViewer = (_a) => {
    var { componentValues } = _a, otherProps = __rest(_a, ["componentValues"]);
    if (typeof window !== 'undefined' && (componentValues === null || componentValues === void 0 ? void 0 : componentValues.playbackUrl)) {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(VideoContainer, null,
                React.createElement(VideoPlayer, Object.assign({ videoSrc: componentValues === null || componentValues === void 0 ? void 0 : componentValues.playbackUrl, posterSrc: componentValues === null || componentValues === void 0 ? void 0 : componentValues.posterImageUrl }, otherProps)))));
    }
    return null;
};
export default VideoViewer;
//# sourceMappingURL=index.js.map